export default "/images/Building-decarb.jpg";